import { ChevronDown, User } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1920&q=80")',
        }}
      ></div>
      <div className="absolute inset-0 bg-helix-dark/85"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-helix-dark/50 via-transparent to-helix-dark/80"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        <div className="mb-8 animate-fade-in-up flex flex-col items-center" style={{ animationDelay: '0.1s' }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_site-clone-quiz/artifacts/0dzx8831_image.png"
            alt="HelixAspire Logo"
            className="h-24 sm:h-28 lg:h-32 object-contain mb-4"
          />
          <span className="text-white text-3xl sm:text-4xl lg:text-5xl font-light tracking-wide">
            helixaspire
          </span>
          <div className="mt-4 text-white/90 text-lg sm:text-xl lg:text-2xl tracking-[0.15em] uppercase font-light">
            <span>Innovation. Curiosity.</span>
          </div>
          <div className="text-white/90 text-lg sm:text-xl lg:text-2xl tracking-[0.15em] uppercase font-light">
            <span>Courage.</span>
          </div>
        </div>

        <h1
          data-testid="hero-title"
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-fade-in-up"
          style={{ animationDelay: '0.2s' }}
        >
          <div className="py-2">Open Source Intelligence</div>
          <div className="py-2">
            <span className="text-white">and Security Risk</span>
          </div>
          <div className="py-2">Specialists</div>
        </h1>

        <p
          data-testid="hero-description"
          className="text-lg sm:text-xl text-white/80 max-w-3xl mx-auto mb-10 leading-relaxed animate-fade-in-up"
          style={{ animationDelay: '0.3s' }}
        >
          Transforming OSINT with cutting-edge technology we connecting all relevant data points to deliver faster, cost-effective, actionable insights.
        </p>

        <div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up"
          style={{ animationDelay: '0.4s' }}
        >
          <button
            data-testid="hero-cta-contact"
            onClick={() => scrollToSection('contact')}
            className="bg-helix-orange hover:bg-helix-orange-dark text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 hover:scale-[1.02] shadow-lg shadow-helix-orange/25"
          >
            Get in Touch
          </button>
          <button
            data-testid="hero-cta-services"
            onClick={() => scrollToSection('services')}
            className="border-2 border-white/40 hover:border-white text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 hover:bg-white/10"
          >
            Explore Services
          </button>
        </div>

        <div className="mt-16 animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
          <button
            onClick={() => scrollToSection('founder')}
            className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors group"
          >
            <div className="w-8 h-8 rounded-full border border-white/30 flex items-center justify-center group-hover:border-white/60 transition-colors">
              <User className="w-4 h-4" />
            </div>
            <span className="text-sm tracking-wide uppercase">Meet the Founder</span>
          </button>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-6 h-6 text-white/40" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
